import { ComplianzConsent } from '../types/Global'; // Adjust path as needed

/**
 * Reads and parses ALL Complianz cookies (cmplz_*) from the document.
 * @returns A consent object, e.g., { statistics: 'allow', marketing: 'deny' }
 */
export const getComplianzConsent = (): ComplianzConsent => {
    const cookiePrefix = 'cmplz_';
    const decodedCookie = decodeURIComponent(document.cookie);

    // Split cookies and build the consent object
    return decodedCookie.split(';').reduce((acc, cookie) => {
        // 1. Get the key/value pair for the current cookie
        const [cookieName, cookieValue] = cookie.trim().split('=');

        // 2. Check if it's a valid cookie and if it matches our prefix
        if (cookieName && cookieValue && cookieName.startsWith(cookiePrefix)) {
            // 3. Extract the category name (e.g., "marketing" from "cmplz_marketing")
            const category = cookieName.substring(cookiePrefix.length);

            // 4. Add it to our consent object
            acc[category] = cookieValue as 'allow' | 'deny';
        }

        return acc;
    }, {} as ComplianzConsent); // Start with an empty consent object
};
